import { render, staticRenderFns } from "./hzFlow.vue?vue&type=template&id=8d8c0ab2&scoped=true"
import script from "./hzFlow.vue?vue&type=script&lang=js"
export * from "./hzFlow.vue?vue&type=script&lang=js"
import style0 from "./hzFlow.vue?vue&type=style&index=0&id=8d8c0ab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8c0ab2",
  null
  
)

export default component.exports